import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { get } from 'lodash'

import { getDeviceSubtype } from '../selectors/config'
import { getIsKiosk } from '../selectors/menus'
import DeviceSubtypes from '../utils/deviceSubtypes'

const DeviceSubtypeRouter = ({ deviceSubtype, history, isKiosk }) => {
  const deviceSubtypeRootPath = () => {
    if (DeviceSubtypes.isConcessions(deviceSubtype)) {
      return '/concession-order'
    } else if (isKiosk) {
      return '/kiosk/attract_loop'
    } else {
      return '/revenue-center-setup'
    }
  }

  useEffect(() => {
    history.push(deviceSubtypeRootPath())
  }, [deviceSubtype])

  return (
    <p>Loading...</p>
  )

}

const mapStateToProps = (state) => {
  const deviceSubtype = getDeviceSubtype(state)
  const isKiosk = getIsKiosk(state)

  return {
    deviceSubtype,
    isKiosk
  }
}

export default withRouter(connect(mapStateToProps, undefined)(DeviceSubtypeRouter))
